import { HeadlineType, FormInputs } from '../types';

const templates = {
  magazine_viral: [
    (topic: string, keyword: string) => `The ${topic} Revolution: What ${keyword} Experts Won't Tell You`,
    (topic: string, keyword: string) => `Inside the Secret World of ${topic}: The ${keyword} Files`,
    (topic: string, keyword: string) => `The Dark Truth About ${topic} That's Transforming ${keyword}`,
    (topic: string, keyword: string) => `Why ${topic} Is the Future of ${keyword} (And Why It Matters)`,
    (topic: string, keyword: string) => `The Hidden Power of ${topic}: A ${keyword} Investigation`,
  ],
  seo_blog: [
    (topic: string, keyword: string) => `Ultimate Guide to ${topic}: Master ${keyword} in 2024`,
    (topic: string, keyword: string) => `10 Proven ${topic} Strategies to Dominate ${keyword}`,
    (topic: string, keyword: string) => `How to Transform Your ${topic} Using Advanced ${keyword} Techniques`,
    (topic: string, keyword: string) => `${topic} Mastery: The Complete ${keyword} Blueprint`,
    (topic: string, keyword: string) => `The Science Behind ${topic}: Revolutionary ${keyword} Insights`,
  ],
  psychological: [
    (topic: string, keyword: string) => `Why Your ${topic} Is Failing (And How ${keyword} Can Fix It)`,
    (topic: string, keyword: string) => `The ${topic} Mistake That's Costing You ${keyword} Success`,
    (topic: string, keyword: string) => `Unlock the Secrets of ${topic} With These ${keyword} Hacks`,
    (topic: string, keyword: string) => `${topic} Experts Reveal Game-Changing ${keyword} Methods`,
    (topic: string, keyword: string) => `The Psychology of ${topic}: Master ${keyword} Forever`,
  ],
  commercial: [
    (topic: string, keyword: string) => `Transform Your ${topic} With Professional ${keyword} Solutions`,
    (topic: string, keyword: string) => `The ROI of ${topic}: Maximizing ${keyword} Performance`,
    (topic: string, keyword: string) => `Scale Your ${topic} Using Proven ${keyword} Systems`,
    (topic: string, keyword: string) => `${topic} Excellence: The Ultimate ${keyword} Framework`,
    (topic: string, keyword: string) => `Enterprise ${topic}: Advanced ${keyword} Strategies`,
  ],
};

const generateMetrics = (goal: string) => {
  const baseMetrics = {
    emotional: Math.floor(Math.random() * 3) + 7,
    curiosity: Math.floor(Math.random() * 3) + 7,
    ctr: Number((Math.random() * 2 + 3).toFixed(1)),
    seo: Math.floor(Math.random() * 3) + 7,
  };

  // Adjust metrics based on content goal
  switch (goal) {
    case 'educational':
      return { ...baseMetrics, seo: baseMetrics.seo + 1 };
    case 'commercial':
      return { ...baseMetrics, ctr: baseMetrics.ctr + 0.5 };
    case 'entertainment':
      return { ...baseMetrics, emotional: baseMetrics.emotional + 1 };
    case 'buyer-intent':
      return { ...baseMetrics, ctr: baseMetrics.ctr + 1 };
    default:
      return baseMetrics;
  }
};

const selectTemplatesByGoal = (goal: string, platform: string) => {
  let templates_pool = [];
  
  switch (goal) {
    case 'educational':
      templates_pool = [...templates.seo_blog, ...templates.psychological];
      break;
    case 'commercial':
      templates_pool = [...templates.commercial, ...templates.psychological];
      break;
    case 'entertainment':
      templates_pool = [...templates.magazine_viral, ...templates.psychological];
      break;
    case 'buyer-intent':
      templates_pool = [...templates.commercial, ...templates.seo_blog];
      break;
    default:
      templates_pool = Object.values(templates).flat();
  }

  // Adjust for platform
  if (platform === 'social') {
    templates_pool = templates_pool.map(template => (topic: string, keyword: string) => 
      template(topic, keyword).split(':')[0]); // Shorter versions for social
  }

  return templates_pool;
};

export function generateHeadlines(inputs: FormInputs): HeadlineType[] {
  const selectedTemplates = selectTemplatesByGoal(inputs.goal, inputs.platform);
  const shuffledTemplates = [...selectedTemplates]
    .sort(() => Math.random() - 0.5)
    .slice(0, 10);

  return shuffledTemplates.map((template) => ({
    title: template(inputs.topic, inputs.keyword),
    metrics: generateMetrics(inputs.goal),
  }));
}